import { ChangeDetectionStrategy, Component, HostListener, ViewEncapsulation, Input } from '@angular/core';
import { FiWrapperTableCellBase } from '@fi-shared/fi-wrapper-table/cells/fi-wrapper-table-cell-base';
import { IContactModel } from '@fi-shared/models/common';
import { FiContactsService } from '@fi-shared/fi-contacts/fi-contacts.service';

export enum WrapperTableContactTypes {
    Email,
    Phone,
}

@Component({
    selector: 'fi-wrapper-table-contacts-cell',
    template: `
        <span class="cell-items-wrapper">
          @for (contactModel of value; track contactModel; let index = $index) {
            <a
              class="BrandedColorHover"
              [href]="getHref(contactModel)"
              [textContent]="getTextContent(contactModel)"
              [attr.title]="getTextContent(contactModel)"
            ></a>
            @if (index !== value.length - 1) {
              <span>, </span>
            }
          }
        </span>
        `,
    styleUrls: ['./fi-wrapper-table-contacts-cell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-wrapper-table-contacts-cell' },
    standalone: false,
})
export class FiWrapperTableContactsCellComponent extends FiWrapperTableCellBase<IContactModel[]> {
    constructor(private fiContactsService: FiContactsService) {
        super();
    }

    @Input() contactType: WrapperTableContactTypes;

    @HostListener('click', ['$event']) onClick($event: MouseEvent) {
        $event.stopPropagation();
    }

    getHref(contactModel: IContactModel): string {
        return this.contactType === WrapperTableContactTypes.Email
            ? `mailto:${contactModel.ContactValue}`
            : `tel:${this.fiContactsService.getFullContactValue(contactModel)}`;
    }

    getTextContent(contactModel: IContactModel): string {
        return this.fiContactsService.getFullContactValue(contactModel);
    }
}
